import React, { useContext } from 'react';
import Chart from 'react-google-charts';

import { Card, CardHeader } from '@material-ui/core';
import DashboardContext from 'src/pages/Private/Dashboard/context';
import { defaultChartOptions } from 'src/utils/charts';

const ServiceSolicitationsChart: React.FC = () => {
  const {
    chartsInfo: { servicesSolicitations },
  } = useContext(DashboardContext);

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader
        title="IFEPAF + IFBOLSAS"
        subheader="4 SERVIÇOS MAIS UTILIZADOS"
      />

      <Chart
        chartType="ColumnChart"
        data={servicesSolicitations}
        options={defaultChartOptions}
      />
    </Card>
  );
};

export default ServiceSolicitationsChart;
